import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Table } from "react-bootstrap";
import { Tabs, Card, Input } from "antd";
import "./listings/Pages.css";

const { TabPane } = Tabs;

const DashboardCollections = ({
  searchText,
  setSearchText,
  selectedStaffId,
  setSelectedStaffId,
  selectedUserId,
  setSelectedUserId,
}) => {
  const { staffGroupedData, status, error } = useSelector(
    (state) => state.groupData
  );

  const onSearch = (value) => {
    setSearchText(value);
  };

  // Toggle sub-table for staff
  const toggleStaffSubTable = (staffId) => {
    setSelectedStaffId(selectedStaffId === staffId ? null : staffId);
    setSelectedUserId(null);
  };

  // Toggle sub-table for user
  const toggleUserSubTable = (userId) => {
    setSelectedUserId(selectedUserId === userId ? null : userId);
    setSelectedStaffId(null);
  };

  //  Filtered Staff Collections
const filteredStaffCollections =
  staffGroupedData?.staff_data?.filter(
    (staff) =>
      staff.staff_name
        .toLowerCase()
        .includes(searchText.toLowerCase()) ||
      staff.staff_no
        .toLowerCase()
        .includes(searchText.toLowerCase())
  ) || [];

//  Filtered User Collections
const filteredUserCollections =
  staffGroupedData?.user_data?.filter((user) =>
    user.name.toLowerCase().includes(searchText.toLowerCase())
  ) || [];

//  Staff Totals
const staffTodayTotal = filteredStaffCollections.reduce(
  (sum, s) => sum + Number(s.today_collection || 0),
  0
);

const staffMonthTotal = filteredStaffCollections.reduce(
  (sum, s) => sum + Number(s.month_collection || 0),
  0
);

//  User Totals
const userTodayTotal = filteredUserCollections.reduce(
  (sum, u) => sum + Number(u.today_collection || 0),
  0
);

const userMonthTotal = filteredUserCollections.reduce(
  (sum, u) => sum + Number(u.month_collection || 0),
  0
);

//  Combined Totals
const combinedTodayTotal = staffTodayTotal + userTodayTotal;
const combinedMonthTotal = staffMonthTotal + userMonthTotal;

  return (
    <Tabs defaultActiveKey="staff-collections" tabPosition="top">
      {/* Staff Collections Sub-Tab */}
      <TabPane tab="Staff Collections" key="staff-collections">
        <Card className="recent-activities-card p-2 w-100 ms-2 responsive">
          <div
            className="py-3 px-4 w-100 d-flex justify-content-between align-items-center flex-wrap"
            style={{
              backgroundColor: "#f0f0f0",
              borderBottom: "1px solid #d9d9d9",
            }}
          >
            <h3 className="m-0 fw-600">Staff Collections</h3>
            <Input.Search
              placeholder="Search staff..."
              allowClear
              style={{ width: 250, marginTop: "8px" }}
              onSearch={onSearch}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th className="staff_collection_heading">S.No</th>
                <th className="staff_collection_heading">Staff Name</th>
                <th className="staff_collection_heading">Today Collection</th>
                <th className="staff_collection_heading">
                  This Month Collection
                </th>
              </tr>
            </thead>
            {/* <tbody>
              {status === "succeeded" ? (
                staffGroupedData?.staff_data?.length > 0 ? (
                  staffGroupedData.staff_data
                    .filter(
                      (staff) =>
                        staff.staff_name
                          .toLowerCase()
                          .includes(searchText.toLowerCase()) ||
                        staff.staff_no
                          .toLowerCase()
                          .includes(searchText.toLowerCase())
                    )
                    .map((staff, index) => (
                      <React.Fragment key={staff.staff_id}>
                        <tr
                          onClick={() => toggleStaffSubTable(staff.staff_id)}
                          style={{ cursor: "pointer" }}
                        >
                          <td>{index + 1}</td>
                          <td>{staff.staff_name}</td>
                          <td>{staff.today_collection.toFixed(2)}</td>
                          <td>{staff.month_collection.toFixed(2)}</td>
                        </tr>
                        {selectedStaffId === staff.staff_id &&
                          staff.areas?.length > 0 && (
                            <tr>
                              <td colSpan="4">
                                <Table striped bordered hover responsive>
                                  <thead>
                                    <tr>
                                      <th className="staff_area_collection_heading">
                                        Area Name
                                      </th>
                                      <th className="staff_area_collection_heading">
                                        Today Collection
                                      </th>
                                      <th className="staff_area_collection_heading">
                                        This Month Collection
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {staff.areas.map((area, areaIndex) => (
                                      <tr key={areaIndex}>
                                        <td>{area.area_name}</td>
                                        <td>
                                          {area.today_collection.toFixed(2)}
                                        </td>
                                        <td>
                                          {area.month_collection.toFixed(2)}
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </Table>
                              </td>
                            </tr>
                          )}
                      </React.Fragment>
                    ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center">
                      No staff data available.
                    </td>
                  </tr>
                )
              ) : status === "loading" ? (
                <tr>
                  <td colSpan="4" className="text-center">
                    Loading...
                  </td>
                </tr>
              ) : status === "failed" ? (
                <tr>
                  <td colSpan="4" className="text-center text-danger">
                    Error loading data: {error || "Unknown error"}
                  </td>
                </tr>
              ) : null}
            </tbody> */}
            <tbody>
  {status === "succeeded" ? (
    filteredStaffCollections.length > 0 ? (
      <>
        {filteredStaffCollections.map((staff, index) => (
          <React.Fragment key={staff.staff_id}>
            <tr
              onClick={() => toggleStaffSubTable(staff.staff_id)}
              style={{ cursor: "pointer" }}
            >
              <td>{index + 1}</td>
              <td>{staff.staff_name}</td>
              <td>{Number(staff.today_collection || 0).toFixed(2)}</td>
              <td>{Number(staff.month_collection || 0).toFixed(2)}</td>
            </tr>

            {selectedStaffId === staff.staff_id &&
              staff.areas?.length > 0 && (
                <tr>
                  <td colSpan="4">
                    <Table striped bordered hover responsive>
                      <thead>
                        <tr>
                          <th className="staff_area_collection_heading">
                            Area Name
                          </th>
                          <th className="staff_area_collection_heading">
                            Today Collection
                          </th>
                          <th className="staff_area_collection_heading">
                            This Month Collection
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {staff.areas.map((area, areaIndex) => (
                          <tr key={areaIndex}>
                            <td>{area.area_name}</td>
                            <td>
                              {Number(area.today_collection || 0).toFixed(2)}
                            </td>
                            <td>
                              {Number(area.month_collection || 0).toFixed(2)}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </td>
                </tr>
              )}
          </React.Fragment>
        ))}

        {/* TOTAL ROW */}
        <tr style={{ fontWeight: "bold", backgroundColor: "#f5f5f5" }}>
          <td colSpan="2" className="text-center">
            TOTAL
          </td>
          <td>{combinedTodayTotal.toFixed(2)}</td>
          <td>{combinedMonthTotal.toFixed(2)}</td>
        </tr>
      </>
    ) : (
      <tr>
        <td colSpan="4" className="text-center">
          No staff data available.
        </td>
      </tr>
    )
  ) : status === "loading" ? (
    <tr>
      <td colSpan="4" className="text-center">
        Loading...
      </td>
    </tr>
  ) : status === "failed" ? (
    <tr>
      <td colSpan="4" className="text-center text-danger">
        Error loading data: {error || "Unknown error"}
      </td>
    </tr>
  ) : null}
</tbody>
          </Table>
        </Card>
      </TabPane>
      {/* User Collections Sub-Tab */}
      <TabPane tab="User Collections" key="user-collections">
        <Card className="recent-activities-card p-2 w-100 ms-2 responsive">
          <div
            className="py-3 px-4 w-100 d-flex justify-content-between align-items-center flex-wrap"
            style={{
              backgroundColor: "#f0f0f0",
              borderBottom: "1px solid #d9d9d9",
            }}
          >
            <h3 className="m-0 fw-600">User Collections</h3>
            <Input.Search
              placeholder="Search user..."
              allowClear
              style={{ width: 250, marginTop: "8px" }}
              onSearch={onSearch}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th className="user_collection_heading">S.No</th>
                <th className="user_collection_heading">User Name</th>
                <th className="user_collection_heading">Today Collection</th>
                <th className="user_collection_heading">
                  This Month Collection
                </th>
              </tr>
            </thead>
            {/* <tbody>
              {status === "succeeded" ? (
                staffGroupedData?.user_data?.length > 0 ? (
                  staffGroupedData.user_data
                    .filter((user) =>
                      user.name.toLowerCase().includes(searchText.toLowerCase())
                    )
                    .map((user, index) => (
                      <React.Fragment key={user.user_id}>
                        <tr
                          onClick={() => toggleUserSubTable(user.user_id)}
                          style={{ cursor: "pointer" }}
                        >
                          <td>{index + 1}</td>
                          <td>{user.name}</td>
                          <td>{user.today_collection.toFixed(2)}</td>
                          <td>{user.month_collection.toFixed(2)}</td>
                        </tr>
                        {selectedUserId === user.user_id &&
                          user.areas?.length > 0 && (
                            <tr>
                              <td colSpan="4">
                                <Table striped bordered hover responsive>
                                  <thead>
                                    <tr>
                                      <th className="user_area_collection_heading">
                                        Area Name
                                      </th>
                                      <th className="user_area_collection_heading">
                                        Today Collection
                                      </th>
                                      <th className="user_area_collection_heading">
                                        This Month Collection
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {user.areas.map((area, areaIndex) => (
                                      <tr key={areaIndex}>
                                        <td>{area.area_name}</td>
                                        <td>
                                          {area.today_collection.toFixed(2)}
                                        </td>
                                        <td>
                                          {area.month_collection.toFixed(2)}
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </Table>
                              </td>
                            </tr>
                          )}
                      </React.Fragment>
                    ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center">
                      No user data available.
                    </td>
                  </tr>
                )
              ) : status === "loading" ? (
                <tr>
                  <td colSpan="4" className="text-center">
                    Loading...
                  </td>
                </tr>
              ) : status === "failed" ? (
                <tr>
                  <td colSpan="4" className="text-center text-danger">
                    Error loading data: {error || "Unknown error"}
                  </td>
                </tr>
              ) : null}
            </tbody> */}
            <tbody>
  {status === "succeeded" ? (
    filteredUserCollections.length > 0 ? (
      <>
        {filteredUserCollections.map((user, index) => (
          <React.Fragment key={user.user_id}>
            <tr
              onClick={() => toggleUserSubTable(user.user_id)}
              style={{ cursor: "pointer" }}
            >
              <td>{index + 1}</td>
              <td>{user.name}</td>
              <td>{Number(user.today_collection || 0).toFixed(2)}</td>
              <td>{Number(user.month_collection || 0).toFixed(2)}</td>
            </tr>

            {selectedUserId === user.user_id &&
              user.areas?.length > 0 && (
                <tr>
                  <td colSpan="4">
                    <Table striped bordered hover responsive>
                      <thead>
                        <tr>
                          <th className="user_area_collection_heading">
                            Area Name
                          </th>
                          <th className="user_area_collection_heading">
                            Today Collection
                          </th>
                          <th className="user_area_collection_heading">
                            This Month Collection
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {user.areas.map((area, areaIndex) => (
                          <tr key={areaIndex}>
                            <td>{area.area_name}</td>
                            <td>
                              {Number(area.today_collection || 0).toFixed(2)}
                            </td>
                            <td>
                              {Number(area.month_collection || 0).toFixed(2)}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </td>
                </tr>
              )}
          </React.Fragment>
        ))}

        {/*  TOTAL ROW */}
        <tr style={{ fontWeight: "bold", backgroundColor: "#f5f5f5" }}>
          <td colSpan="2" className="text-center">
            TOTAL
          </td>
          <td>{combinedTodayTotal.toFixed(2)}</td>
          <td>{combinedMonthTotal.toFixed(2)}</td>
        </tr>
      </>
    ) : (
      <tr>
        <td colSpan="4" className="text-center">
          No user data available.
        </td>
      </tr>
    )
  ) : status === "loading" ? (
    <tr>
      <td colSpan="4" className="text-center">
        Loading...
      </td>
    </tr>
  ) : status === "failed" ? (
    <tr>
      <td colSpan="4" className="text-center text-danger">
        Error loading data: {error || "Unknown error"}
      </td>
    </tr>
  ) : null}
</tbody>
          </Table>
        </Card>
      </TabPane>
    </Tabs>
  );
};

export default DashboardCollections;
